import { render, staticRenderFns } from "./order-view-payments.vue?vue&type=template&id=daf068a0&"
import script from "./order-view-payments.ts?vue&type=script&lang=ts&"
export * from "./order-view-payments.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports